export default "__VITE_ASSET__705a5755__"